import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';

import { useAppDispatch, useMobile } from '@pkg/hooks';

import { updateNFTManagerFilters } from '@app/store/actions/nft-manager';

import { StyledButton, StyledHeading, StyledText, StyledYatHand, UnsupportedWrapper } from './styles';

export function NoMatchingUnsupported() {
    const { t: translate } = useTranslation(['yat_nft_manager']);

    const dispatch = useAppDispatch();
    const { isMobile } = useMobile();

    const updateUnsupportedFilter = useCallback(() => {
        dispatch(
            updateNFTManagerFilters({
                filter: { unsupported: false },
            }),
        );
    }, [dispatch]);

    return (
        <UnsupportedWrapper>
            <StyledYatHand />
            <StyledHeading>{translate('yat_nft_manager_no_results_unsupported_title')}</StyledHeading>
            <StyledText>{translate('yat_nft_manager_no_results_unsupported_text')}</StyledText>
            <StyledButton size={isMobile ? 'large' : 'small'} color="secondary" onClick={updateUnsupportedFilter}>
                {translate('yat_nft_manager_no_results_unsupported_button')}
            </StyledButton>
        </UnsupportedWrapper>
    );
}
